import React, { Component } from 'react'
import { connect } from 'react-redux'

class BoxSearch extends Component {
  constructor (props) {
    super(props)
    this.state = {
      toggled: false
    }
  }
  showField () {
    this.setState({toggled: true})
  }
  onBlur (e) {
    if (e.target.value) return
    this.setState({toggled: false})
  }
  render () {
    if (!this.props.filter) return null
    if (!this.state.toggled) {
      return (
        <a className='pull-right box-button' onClick={e => this.showField()}><i className='fa fa-fw fa-search' /></a>
      )
    }
    return (
      <div className={(this.props.filter ? 'table-search-wrapper' : 'hidden') + ' hidden-xs'}>
        <div className='form-group table-search-form-group'>
          <i className='fa fa-search' />
          <input
            autoFocus
            type='text'
            className='form-control'
            id='table-search-input'
            onChange={e => this.props.filter(e)}
            onKeyUp={e => this.props.filter(e)}
            onBlur={e => this.onBlur(e)} />
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
BoxSearch = connect(state => state)(BoxSearch)
export default BoxSearch



// WEBPACK FOOTER //
// ./src/components/basic/containers/BoxSearch.js